// extracted by mini-css-extract-plugin
module.exports = {"cnrfngm":"cnrfngm","footer":"footer","sc842ti":"sc842ti"};